import type { TabKey } from "../session/tab-context";

// Le chiavi di cache delle Opportunità (piano M6, R8, Task 25), in un modulo senza altre dipendenze: le usano la pagina
// «Opportunità», il riquadro della scheda e gli appuntamenti (R7), il cui esito fa avanzare la fase.

export const opportunityKeys = {
  /** Tutto ciò che la scheda ha letto delle Opportunità: il prefisso delle altre chiavi. */
  all: (tab: TabKey) => ["scheda", tab, "opportunities"] as const,
  /** Il riepilogo della pagina (conto per fase, valore, campagne) con i filtri e, per il mese, il periodo. */
  summary: (tab: TabKey, view: string | null, query: unknown) => ["scheda", tab, "opportunities", "summary", view, query] as const,
  /** Le pagine di una colonna o della «Tabella», con la fase, «Di chi», campagna e ricerca, in una vista (`null` fuori dalla «Guarda come…»). */
  list: (tab: TabKey, view: string | null, query: unknown) => ["scheda", tab, "opportunities", "list", view, query] as const,
  /** L'Opportunità di adesso di un Lead, per il riquadro della scheda. */
  lead: (tab: TabKey, view: string | null, leadId: string) => ["scheda", tab, "opportunities", "lead", view, leadId] as const,
  /** Il dettaglio di un'Opportunità, con i suoi appuntamenti. */
  detail: (tab: TabKey, view: string | null, opportunityId: string) => ["scheda", tab, "opportunities", "detail", view, opportunityId] as const,
};
